import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form, Button as BootstrapButton } from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import Card from '../../../components/Card'
import { API_COMPANY_LIST, API_COMPANY_CREDITS, API_COMPANY_PROFILE, API_TTS_CREDITS, API_COMPANY_SWITCH_DEFAULT_USER } from '../../../service/url';
import switchUserIcon from '../../../assets/images/icons/switch-user.png';
import { switchUser } from '../../../utilities/setting';
import Modal from "react-bootstrap/Modal";
import { getApiCall, postApiCall } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Loader  from '../../../components/partials/components/loader';
import {
  Target,
  Users,
  MapPin,
  Flag,
  Building2,
  Phone,
  Hash,
  User,
  Calendar,
  CalendarClock,
  UserRound,
} from 'lucide-react';
import CountryCodeDirectionsModal from '../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionsModal';
import "../../../assets/custom/css/custom.css";
import { ROUTES, USER_CREDITS_ACTION, TTS_CREDITS_ACTION } from '../../../utilities/constant';
import { USER_ROLES , MODULE_ACL} from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { Dropdown as BootstrapDropdown } from "react-bootstrap";
import RenderAddCreditModal from "../../../components/partials/components/add-credit-model";
import RenderRemoveCreditModal from "../../../components/partials/components/remove-credit-model";
import { toast } from 'react-toastify';
import exportData from '../../../utilities/export';
import { API_COMPANY_DELETE } from '../../../service/url';
import { FaTrash } from "react-icons/fa";
import LicenceHistoryList from '../licence_history/list';

//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import { FiPlus } from 'react-icons/fi';

const CompanyList = () =>{

   const navigate = useNavigate();
   const [companylist, setCompanylist] = useState([]);
   const [loading, setLoading] = useState(false);
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [isReseller, setIsReseller] = useState(false)
   const [currentUserId, setCurrentUserId] = useState("")
   const [currentUserRole, setCurrentUserRole] = useState("")
   const [addCreditsId, setAddCreditsId] = useState(null);
   const [removeCreditsId, setRemoveCreditsId] = useState(null);
   const [showRemoveCreditModel, setShowRemoveCreditModel] = useState(false);
   const [confirmReduceCredits, setConfirmReduceCredits] = useState(false);
   const [removeCreditsValue, setRemoveCreditsValue] = useState(0);
   const [showAddCreditModel, setShowAddCreditModel] = useState(false);
   const [confirmCredits, setConfirmCredits] = useState(false);
   const [addCreditsValue, setAddCreditsValue] = useState(0);
   const [showGroupsModal, setShowGroupsModal] = useState(false);
   const [showLocationsModal, setShowLocationsModal] = useState(false);
   const [selectedCompanyName, setSelectedCompanyName] = useState(null);
   const [selectedGroups, setSelectedGroups] = useState([]);
   const [selectedLocations, setSelectedLocations] = useState([]);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [deleteId, setDeleteId] = useState(null);

   const [toastProps, setToastProps] = useState(null);
   const [showToast, setShowToast] = useState(false);
   const [searchValue, setSearchValue] = useState("");
   const [loggedInUser, setLoggedInUser] = useState(null);
   const [isOwnCompany, setIsOwnCompany] = useState(false);
   const [showStrategiesModal, setShowStrategiesModal] = useState(false);
   const [userCallStratgies, setUserCallStrategies] = useState(null);
   const [userCallStrategiesUserName, setUserCallStrategiesUserName] = useState(null);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})

   const [showAddTtsCreditModel, setShowAddTtsCreditModel] = useState(false);
   const [confirmTtsCredits, setConfirmTtsCredits] = useState(false);
     const [addTtsCreditsValue, setAddTtsCreditsValue] = useState(0);
     const [showRemoveTtsCreditModel, setShowRemoveTtsCreditModel] = useState(false);
     const [confirmReduceTtsCredits, setConfirmReduceTtsCredits] = useState(false);
     const [removeTtsCreditsValue, setRemoveTtsCreditsValue] = useState(0);

     const [addTtsCreditsId, setAddTtsCreditsId] = useState(null);
     const [removeTtsCreditsId, setRemoveTtsCreditsId] = useState(null);
     const [loggedInUserId, setLoggedInUserId] = useState(null);
     const [buttonDisable, setButtonDisable] = useState(false);
     const [showLicenceHistoryModal, setShowLicenceHistoryModal] = useState(false);
     const [selectedLicenceCompanyId, setSelectedLicenceCompanyId] = useState(null);
     const [selectedLicenceCompanyName, setSelectedLicenceCompanyName] = useState(null);
   const [showCcDirectionsModal, setShowCcDirectionsModal] = useState(false);
   const [ccDirectionsData, setCcDirectionsData] = useState([]);
   const [ccDirectionsOwner, setCcDirectionsOwner] = useState("");
   const [isSwitchingAccount, setIsSwitchingAccount] = useState(false);
   const [showCompanyDetailsModal, setShowCompanyDetailsModal] = useState(false);
   const [selectedCompanyDetails, setSelectedCompanyDetails] = useState(null);

    useEffect(() => {
        const user = getUser();
          if (user) {
            setLoggedInUser(user);
            setCurrentUserId(user.id)
            setCurrentUserRole(user.role)
            setLoggedInUserId(user.id);
            if (user.role === USER_ROLES.SUPERADMIN) {
               setIsSuperadmin(true);
            }
            if (user.role === USER_ROLES.RESELLER) {
               setIsReseller(true);
            }
            if (user?.acl_settings) {
               setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
            }
          }
      }, []);

        // useEffect(() => {
        //   if (toastProps) {
        //     setShowToast(true);
        //   }
        // }, [toastProps]);

        const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

          useEffect(() => {
            const user = getUser();
              if (user) {
                if (user?.acl_settings) {
                  setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
                }
              }
          }, []);

          useEffect(() => {
            const onAclRefreshed = () => {
              const user = getUser();
              if (user?.acl_settings?.module_operations) {
                try {
                  const parsed = typeof user.acl_settings.module_operations === "string"
                    ? JSON.parse(user.acl_settings.module_operations)
                    : user.acl_settings.module_operations;
                  setLoggedInUserACL(parsed);
                  setModuleOperationsForReadPermissionCheck(parsed);
                } catch (e) {
                  console.log("Failed to apply refreshed ACL", e);
                }
              }
            };
            window.addEventListener("acl-refreshed", onAclRefreshed);
            return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
          }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchAssignedCompany = async () => {
      if (!loggedInUser) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        if (
          loggedInUser?.assignedCompany &&
          loggedInUser.assignedCompany?.is_own_company
        ) {
          const assignedCompanyId =
            loggedInUser?.assignedCompany?.id ??
            loggedInUser?.assigned_company;
          if (!assignedCompanyId) {
            throw new Error("Assigned company id not found for this user");
          }
          const fetchedAssignedCompanyData = await getApiCall(
            API_COMPANY_PROFILE.replace(":id", String(assignedCompanyId))
          );

          if (!isMounted) return;

          const licence = fetchedAssignedCompanyData?.subUserLicenceId?.available_licence || {};

          const assignedCompanyOfLoggedInUser = [
            {
              key: 1,
              name: loggedInUser.assignedCompany.name,
              phone: loggedInUser.assignedCompany.phone,
              address: loggedInUser.assignedCompany.address,
              pincode: loggedInUser.assignedCompany.pincode,
              credits_available:
                loggedInUser.assignedCompany.credits_available,
              created_at: loggedInUser.assignedCompany.created_at,
              updated_at: loggedInUser.assignedCompany.updated_at,
              company_creator: {
                username: loggedInUser?.createdByUser?.username
              },
              available_licence: licence,
              is_own_company: loggedInUser?.assignedCompany?.is_own_company,
              is_reseller_company: loggedInUser?.assignedCompany?.is_reseller_company,
              company_code: loggedInUser?.assignedCompany?.company_code,
              companyCallStrategies: loggedInUser?.assignedCompany?.companyCallStrategies || [],
              companyGroups: loggedInUser?.assignedCompany?.companyGroups || [],
              companyLocations: loggedInUser?.assignedCompany?.companyLocations || [],
            }
          ];

          setCompanylist(assignedCompanyOfLoggedInUser);
          setIsOwnCompany(true);
        } else {
          const list = await getApiCall(API_COMPANY_LIST, {});
          if (!isMounted) return;
          onCompanyListSuccess(list);
          setIsOwnCompany(false);
        }
      } catch (err) {
        onError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAssignedCompany();

    return () => {
      isMounted = false;
    };
  }, [loggedInUser]);

   async function handleAddCredits(id) {
      setShowAddCreditModel(true);
      setAddCreditsId(id);
   }
  
    async function handleRemoveCredits(id) {
      const company = companylist.find(c => c.id === id);
      setShowRemoveCreditModel(true);
      setRemoveCreditsId(id);
      setRemoveCreditsValue(0);
      // Store available credits for validation
      if (company) {
        setRemoveCreditsValue(0);
      }
    }

    async function handleAddTtsCredits(id) {
      setShowAddTtsCreditModel(true);
      setAddTtsCreditsId(id);
    }

    async function handleRemoveTtsCredits(id) {
      const company = companylist.find(c => c.id === id);
      setShowRemoveTtsCreditModel(true);
      setRemoveTtsCreditsId(id);
      setRemoveTtsCreditsValue(0);
      // Store available TTS credits for validation
      if (company) {
        setRemoveTtsCreditsValue(0);
      }
    }

    const handleExport = async () => {
   try {
      // setButtonDisable(true);

      exportToCSV({
         fileName: "companies-list",
         data: displayedCompanyList,
         columns: [
            {
               header: "#",
               accessor: "key"
            },
            {
               header: "Name",
               accessor: (row) => row.name || "-"
            },
            {
               header: "Phone",
               accessor: (row) => row.phone || "-"
            },
            {
               header: "Address",
               accessor: (row) => row.address || "-"
            },
            {
               header: "Pincode",
               accessor: (row) => row.pincode || "-"
            },
            {
               header: "Company Code",
               accessor: (row) =>
                  Number(row.company_code)
                     ? row.company_code
                     : "-"
            },
            {
               header: "Type",
               accessor: (row) => {
                  if (row.is_reseller_company) {
                     return "Reseller Company";
                  }
                  if (row.is_own_company) {
                     return "End User";
                  }
                  return "-";
               }
            },
            {
               header: "Voice Credits",
               accessor: (row) =>
                  row.credits_available || 0
            },
            {
               header: "TTS Credits",
               accessor: (row) =>
                  row.tts_credits || 0
            },
            {
               header: "Call Strategies",
               accessor: (row) =>
                  row.strategies?.map(
                     s => s.strategy_name || s.name
                  ).join(", ") || "-"
            },
            {
               header: "Company Groups",
               accessor: (row) =>
                  row.groups?.map(
                     g => g.group_name
                  ).join(", ") || "-"
            },
            {
               header: "Company Locations",
               accessor: (row) =>
                  row.locations?.map(
                     l => l.location_name
                  ).join(", ") || "-"
            },
            {
               header: "Created By",
               accessor: (row) =>
                  row.company_creator?.username || "-"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Updated Date",
               accessor: (row) =>
                  new Date(row.updated_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      // setButtonDisable(false);
   }
};

    const getCompanyInitials = (name) => {
      if (!name?.trim()) return "?";
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
      return name.slice(0, 2).toUpperCase();
    };

    const getCompanyTypeInfo = (row) => {
      if (row.is_reseller_company) return { label: "Reseller Company", variant: "reseller" };
      if (row.is_own_company) return { label: "End User", variant: "enduser" };
      return { label: "-", variant: "neutral" };
    };

    const formatCreditAmount = (val) => {
      const n = Number(val);
      return Number.isNaN(n) ? "0.00" : n.toFixed(2);
    };

    const getActiveStrategies = (row) =>
      (row.companyCallStrategies || []).filter((x) => x.strategyMaster && !x.is_deleted);

    const getActiveGroups = (row) =>
      (row.companyGroups || []).filter((g) => g.groups && !g.groups.is_deleted);

    const getActiveLocations = (row) =>
      (row.companyLocations || []).filter((l) => l.locations && !l.locations.is_deleted);

    const getActiveCcDirections = (row) =>
      (row.companyCountryCodeDirections || []).filter((r) => r.directionMaster && !r.is_deleted);

    const openCompanyStrategies = (rowData) => {
      const names = getActiveStrategies(rowData).map((x) => x.strategyMaster.name);
      setUserCallStrategies(names.join(", "));
      setUserCallStrategiesUserName(rowData.name);
      setShowStrategiesModal(true);
    };

    const openCompanyGroups = (rowData) => {
      setSelectedGroups(getActiveGroups(rowData).map((g) => g.groups.group_name));
      setSelectedCompanyName(rowData.name);
      setShowGroupsModal(true);
    };

    const openCompanyLocations = (rowData) => {
      setSelectedLocations(getActiveLocations(rowData).map((l) => l.locations.location_name));
      setSelectedCompanyName(rowData.name);
      setShowLocationsModal(true);
    };

    const openCompanyCcDirections = (rowData) => {
      setCcDirectionsData(getActiveCcDirections(rowData));
      setCcDirectionsOwner(rowData.name);
      setShowCcDirectionsModal(true);
    };

    const openCompanyLicenceHistory = (rowData) => {
      setSelectedLicenceCompanyId(rowData.id);
      setSelectedLicenceCompanyName(rowData.name);
      setShowLicenceHistoryModal(true);
    };

    const QuickAccessBtn = ({ title, onClick, disabled, children, accent }) => (
      <button
        type="button"
        className={`company-list-quick-btn company-list-quick-btn--${accent}${disabled ? " is-disabled" : ""}`}
        title={title}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
      >
        {children}
      </button>
    );

   const ccDirectionsTemplate = (rowData) => {
     const rows = (rowData.companyCountryCodeDirections || []).filter(r => r.directionMaster && !r.is_deleted);
     if (rows.length === 0) {
       return <span style={{ color: "#6b7280", fontSize: "13px" }}>No Directions</span>;
     }
     return (
       <Button
         onClick={() => {
           setCcDirectionsData(rows);
           setCcDirectionsOwner(rowData.name);
           setShowCcDirectionsModal(true);
         }}
         className="p-button-active p-button-sm"
         style={{ padding: "5px 10px", display: "inline-flex", alignItems: "center", gap: "6px" }}
       >
         <Flag size={16} />
         <span>View Codes</span>
       </Button>
     );
   };
    const companyNameBody = (rowData) => {
      const code = Number(rowData.company_code) ? String(rowData.company_code).padStart(4, "0") : null;
      return (
        <div className="company-list-cell company-list-cell--company">
          <span className="company-list-avatar">{getCompanyInitials(rowData.name)}</span>
          <div className="company-list-company-text">
            <span className="company-list-company-name">{rowData.name || "-"}</span>
            {code && <span className="company-list-company-code">Code: {code}</span>}
          </div>
        </div>
      );
    };

    const openCompanyDetailsModal = (rowData) => {
      setSelectedCompanyDetails(rowData);
      setShowCompanyDetailsModal(true);
    };

    const companyDetailsButtonBody = (rowData) => (
      <Button
        label="View details"
        className="btn btn-primary company-list-view-btn"
        onClick={() => openCompanyDetailsModal(rowData)}
      />
    );

    const licenceHistoryButtonBody = (rowData) => (
      <Button
        label="View History"
        className="btn btn-primary company-list-license-btn"
        onClick={() => openCompanyLicenceHistory(rowData)}
      />
    );

    const defaultUserBody = (rowData) => {
      const defaultUser = rowData.defaultUser;
      const canSwitchDefaultUser =
        Boolean(defaultUser?.id) && Number(defaultUser?.status) === 1;

      return (
        <div className="company-list-default-user-cell">
          {canSwitchDefaultUser && (
            <span
              className="company-list-default-user-switch"
              title={
                isSwitchingAccount
                  ? "Switching..."
                  : `Switch to ${defaultUser.username}`
              }
              onClick={() => {
                if (!isSwitchingAccount) {
                  switchToDefaultUser(rowData);
                }
              }}
              style={{
                opacity: isSwitchingAccount ? 0.6 : 1,
                cursor: isSwitchingAccount ? "not-allowed" : "pointer",
              }}
            >
              <img alt="Switch to default user" src={switchUserIcon} width={26} />
            </span>
          )}
          <span className="company-list-default-user">
            {defaultUser?.username || "-"}
          </span>
        </div>
      );
    };

    const formatDetailDateTime = (dateStr) => {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return "-";
      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    const getUpdatedByLabel = (rowData) =>
      rowData.company_updater?.username ||
      rowData.updated_by_user?.username ||
      rowData.updatedBy?.username ||
      "—";

    const typeBody = (rowData) => {
      const { label, variant } = getCompanyTypeInfo(rowData);
      return (
        <span className={`company-list-type-badge company-list-type-badge--${variant}`}>
          <Building2 size={14} />
          {label}
        </span>
      );
    };

    const creditsBody = (rowData) => (
      <div className="company-list-cell company-list-cell--credits">
        <span className="company-list-credit-row">
          <span className="company-list-credit-badge company-list-credit-badge--vc">VC</span>
          <span className="company-list-credit-value">{formatCreditAmount(rowData.credits_available)}</span>
        </span>
        <span className="company-list-credit-row">
          <span className="company-list-credit-badge company-list-credit-badge--tts">TTS</span>
          <span className="company-list-credit-value">{formatCreditAmount(rowData.tts_credits)}</span>
        </span>
      </div>
    );

    const quickAccessBody = (rowData) => {
      const strategies = getActiveStrategies(rowData);
      const groups = getActiveGroups(rowData);
      const locations = getActiveLocations(rowData);
      const directions = getActiveCcDirections(rowData);

      return (
        <div className="company-list-quick-access">
          <QuickAccessBtn
            title={strategies.length ? `Call Strategies (${strategies.length})` : "No strategies"}
            accent="strategy"
            disabled={!strategies.length}
            onClick={() => openCompanyStrategies(rowData)}
          >
            <Target size={16} />
          </QuickAccessBtn>
          <QuickAccessBtn
            title={groups.length ? `Dialer Groups (${groups.length})` : "No groups"}
            accent="groups"
            disabled={!groups.length}
            onClick={() => openCompanyGroups(rowData)}
          >
            <Users size={16} />
          </QuickAccessBtn>
          <QuickAccessBtn
            title={locations.length ? `Locations (${locations.length})` : "No locations"}
            accent="locations"
            disabled={!locations.length}
            onClick={() => openCompanyLocations(rowData)}
          >
            <MapPin size={16} />
          </QuickAccessBtn>
          <QuickAccessBtn
            title={directions.length ? `Country Codes (${directions.length})` : "No country codes"}
            accent="directions"
            disabled={!directions.length}
            onClick={() => openCompanyCcDirections(rowData)}
          >
            <Flag size={16} />
          </QuickAccessBtn>
        </div>
      );
    };

     useEffect(() => {
       if(confirmCredits){
         if (addCreditsValue == 0) {
          toast.error("Please add some credit value to increase");
         }
         else {
           let apiUrl = API_COMPANY_CREDITS.replace(":id", addCreditsId);
           postApiCall(apiUrl, { 
             id: addCreditsId, 
             updatedCredit: addCreditsValue, 
             action: USER_CREDITS_ACTION.ADD, 
             fromUser: currentUserId
           })
           .then(onUserCreditsUpdatedSuccess)
           .catch(onUserCreditsUpdatedFailed)
         }
       }
     }, [confirmCredits, addCreditsValue]);
   
     useEffect(() => {
       if(confirmReduceCredits){
         if (removeCreditsValue == 0) {
          toast.error("Please add some credit value to reduce");
         }
         else {
           let apiUrl = API_COMPANY_CREDITS.replace(":id", removeCreditsId);
           postApiCall(apiUrl, { id: removeCreditsId, updatedCredit: removeCreditsValue, action: USER_CREDITS_ACTION.DEDUCT, fromUser: currentUserId })
           .then(onUserCreditsUpdatedSuccess)
           .catch(onUserCreditsUpdatedFailed)
         }
       }
     }, [confirmReduceCredits, removeCreditsValue]);

     function openDeleteModal(id) {
           setDeleteId(id);
           setShowDeleteModal(true);
        }
     
        function closeDeleteModal() {
           setDeleteId(null);
           setShowDeleteModal(false);
        }
     
        async function confirmDelete() {
           try {
              setButtonDisable(true);
     
              const url = API_COMPANY_DELETE.replace(":id", deleteId);
              await postApiCall(url, {});
              toast.success("Company deleted successfully");
     
              closeDeleteModal();
              setLoading(true);
              const resp = await getApiCall(API_COMPANY_LIST, {});
              onCompanyListSuccess(resp);
     
           } catch (err) {
              toast.error(JSON.stringify(err) || "Failed to delete company");
              onError(err);
           } finally {
              setLoading(false);
              setButtonDisable(false);
           }
        }

  //  function onUserCreditsUpdatedSuccess(resp) {
  //     setConfirmCredits(false);
  //     setConfirmReduceCredits(false);
  //     setRemoveCreditsValue(0);
  //     setAddCreditsValue(0);
  //     setShowAddCreditModel(false);
  //     setShowRemoveCreditModel(false);
  //     toast.success("Company Credits Updated Successfully");
  //   }
  

    function onUserCreditsUpdatedSuccess(resp) {
      const updatedCompanyId = addCreditsId || removeCreditsId;
      const creditDelta = confirmCredits ? Number(addCreditsValue) : -Number(removeCreditsValue);
      setCompanylist(prevList =>
        prevList.map(company => {
          if (company.id === updatedCompanyId) {
            const updatedCredits = Number(company.credits_available || 0) + creditDelta;
            return {
              ...company,
              credits_available: roundTo2(updatedCredits),
            };
          }
          return company;
        })
      );
      setConfirmCredits(false);
      setConfirmReduceCredits(false);
      setRemoveCreditsValue(0);
      setAddCreditsValue(0);
      setShowAddCreditModel(false);
      setShowRemoveCreditModel(false);
      toast.success("Company Credits Updated Successfully");
    }

    function roundTo2(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    }
  
    function onUserCreditsUpdatedFailed(error) {
      setConfirmCredits(false);
      setConfirmReduceCredits(false);
      setRemoveCreditsValue(0);
      setAddCreditsValue(0);
      setShowAddCreditModel(false);
      setShowRemoveCreditModel(false);
      toast.error(error);
    }

   function onCompanyListSuccess(resp){
      if (!Array.isArray(resp)) {
        setCompanylist([]);
        toast.error("Company list response was invalid");
        return;
      }
      const updatedList = resp.map( (val, idx) => {
         val['key'] = idx+1;
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      } );
      setCompanylist(updatedList);
   }

   const handleAllocateClick = (id, role) => {
      navigate(`/allocate/${currentUserId}/${id}/company`);
    };

   async function switchToDefaultUser(companyRow) {
      if (isSwitchingAccount) return;
      const defaultUser = companyRow?.defaultUser;
      if (!defaultUser?.id) {
         toast.error("No default user configured for this company");
         return;
      }
      if (Number(defaultUser.status) !== 1) {
         toast.error("Default user is inactive");
         return;
      }
      setIsSwitchingAccount(true);
      try {
         const url = API_COMPANY_SWITCH_DEFAULT_USER.replace(":id", companyRow.id);
         const response = await postApiCall(url, {});
         const switchAccountSuccess = await switchUser(response);
         if (switchAccountSuccess) {
            toast.success("Switched to company default user");
            setTimeout(() => {
               window.location.href = ROUTES.DASHBOARD;
            }, 1500);
         }
      } catch (err) {
         toast.error(typeof err === "string" ? err : "Failed to switch user");
         setIsSwitchingAccount(false);
      }
   }

   function RenderActionComponent(companyRow) {
      const id = companyRow.id;
      const role = companyRow.category;
      const companyEditRoute = ROUTES.COMPANIES.EDIT.replace(":id", id);
      return (
         <div className="flex align-items-center list-user-action d-flex">
            <BootstrapDropdown>
               <BootstrapDropdown.Toggle
                          variant="primary"
                          size="sm"
                          id={`dropdown-basic-${id}`}
                          className="company-list-actions-toggle"
                        >
                          View Actions
                        </BootstrapDropdown.Toggle>
                         <BootstrapDropdown.Menu
                                      popperConfig={{
                                        modifiers: [
                                          {
                                            name: "preventOverflow",
                                            options: { boundary: "viewport" },
                                          },
                                          {
                                            name: "flip",
                                            options: { fallbackPlacements: ["top", "bottom"] },
                                          },
                                        ],
                                      }}
                                      style={{ maxHeight: "300px", overflowY: "auto" }}
                                    >
                                      {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.COMPANY]?.edit) && (
                                       <BootstrapDropdown.Item onClick={() => navigate(`/${companyEditRoute}`)}>
                                         Edit Company
                                       </BootstrapDropdown.Item>
                                      )}
                                       <BootstrapDropdown.Item onClick={() => handleAllocateClick(id, role)}>
                                          Allocate Number
                                       </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleAddCredits(id)}>
                                          Add Voice Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleRemoveCredits(id)}>
                                          Remove Voice Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleAddTtsCredits(id)}>
                                          Add TTS Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleRemoveTtsCredits(id)}>
                                          Remove TTS Credits
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => openDeleteModal(id)}>
                                          Delete Company
                                        </BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                  </BootstrapDropdown>
         </div>
      );

   }

   function onError(err){
      console.error(err);
      setCompanylist([]);
      const msg =
        typeof err === "string"
          ? err
          : err?.message || "Failed to load company list";
      toast.error(msg);
   }

   const handleCreateButtonClick = () => {
      navigate(`/${ROUTES.COMPANIES.CREATE}`);
   } 

   useEffect(() => {
    if (confirmTtsCredits) {
      if (addTtsCreditsValue == 0) {
        toast.error("Please add some TTS credit value to increase");
      }
      else {
        let apiUrl = API_TTS_CREDITS.replace(":id", addTtsCreditsId);
        postApiCall(apiUrl, {
          id: addTtsCreditsId,
          updatedCredit: addTtsCreditsValue,
          action: TTS_CREDITS_ACTION.ADDITION,
          fromUser: loggedInUserId
        })
        .then(onUserTtsCreditsUpdatedSuccess)
        .catch(onUserTtsCreditsUpdatedFailed)
      }
    }
  }, [confirmTtsCredits, addTtsCreditsValue]);
   
     useEffect(() => {
       if (confirmReduceTtsCredits) {
         if (removeTtsCreditsValue == 0) {
           toast.error("Please add some TTS credit value to reduce");
         }
         else {
           let apiUrl = API_TTS_CREDITS.replace(":id", removeTtsCreditsId);
           postApiCall(apiUrl, { id: removeTtsCreditsId, updatedCredit: removeTtsCreditsValue, action: TTS_CREDITS_ACTION.DEDUCTION, fromUser: loggedInUserId })
             .then(onUserTtsCreditsUpdatedSuccess)
             .catch(onUserTtsCreditsUpdatedFailed)
         }
       }
     }, [confirmReduceTtsCredits, removeTtsCreditsValue]);
   
     function onUserTtsCreditsUpdatedSuccess(resp) {
  const updatedCompanyId = addTtsCreditsId || removeTtsCreditsId;
  const creditDelta = confirmTtsCredits
    ? Number(addTtsCreditsValue)
    : -Number(removeTtsCreditsValue);

  setCompanylist(prevList =>
    prevList.map(company => {
      if (company.id === updatedCompanyId) {
        const updatedTtsCredits = Number(company.tts_credits || 0) + creditDelta;
        return {
          ...company,
          tts_credits: roundTo2(updatedTtsCredits),
        };
      }
      return company;
    })
  );

  setConfirmTtsCredits(false);
  setConfirmReduceTtsCredits(false);
  setRemoveTtsCreditsValue(0);
  setAddTtsCreditsValue(0);
  setShowAddTtsCreditModel(false);
  setShowRemoveTtsCreditModel(false);
  toast.success("Company TTS Credits Updated Successfully");
}

   
     function onUserTtsCreditsUpdatedFailed(error) {
       setConfirmTtsCredits(false);
       setConfirmReduceTtsCredits(false);
       setRemoveTtsCreditsValue(0);
       setAddTtsCreditsValue(0);
       setShowAddTtsCreditModel(false);
       setShowRemoveTtsCreditModel(false);
       toast.error(error);
     }

   const displayedCompanyList = useMemo(() => {
      const q = searchValue.trim().toLowerCase();
      if (!q) return companylist;
      return companylist.filter((c) => (c?.name || "").toLowerCase().includes(q));
   }, [companylist, searchValue]);

   const canRead = hasPermission(
        moduleOperationsForReadPermissionCheck,
        "Company List",
        "read",
      );
    
      if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
        return (
          <div
            className="text-center p-4"
            style={{
              marginTop: "50px",
              marginBottom: "50px",
              fontSize: "16px",
            }}
          >
            No read permission found in assigned ACL
          </div>
        );
      }

   if (loading) {
      return <Loader />
   }

  return(
     <>
       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">Company List</h4>
                     </div>
                     <div className="d-flex justify-content-flex-end">
                     {companylist.length > 0 && !isOwnCompany &&
                        <Button 
                          label="Export Data"
                          icon="pi pi-file-export"
                          onClick={handleExport} 
                          className="p-button-active p-button-sm" 
                          style={{ marginRight: '10px' }} 
                        >
                        </Button>
                      }
                      {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.COMPANY]?.add)
                        ? (!isOwnCompany && (
                            <button
                              className="btn btn-primary ml-auto"
                              onClick={handleCreateButtonClick}
                            >
                              <FiPlus className="me-1" />
                              Create Company
                            </button>
                          ))
                        : null}

                     </div>
                  </Card.Header>
                  <Card.Body className="px-0">
                  <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                     <Form.Group style={{ marginLeft: "10px", marginTop: "10px", marginBottom: "10px", flexShrink: 0 }}>
                        <Form.Control
                           style={{
                              height: "50px",
                              width: "380px",
                              border: "1px solid #ced4da",
                              fontSize: "15px",
                           }}
                           placeholder="Search company by name..."
                           type="text"
                           maxLength={100}
                           value={searchValue}
                           onChange={(e) => setSearchValue(e.target.value)}
                        />
                     </Form.Group>
                  </div>
                  <div className="scroll-container">
                     <div className="table-responsive border-bottom my-3">
                        <DataTable
                          value={displayedCompanyList}
                          paginator
                          rows={8}
                          className={`company-list-datatable${displayedCompanyList.length < 3 && displayedCompanyList.length > 0 ? " increasePaddingBottom" : ""}`}
                        >
                           <Column field="key" header="#" style={{ width: "3rem" }} />
                           <Column header="Company" body={companyNameBody} style={{ minWidth: "11rem" }} />
                           <Column header="Company Details" body={companyDetailsButtonBody} style={{ width: "5.5rem" }} />
                           <Column header="Type" body={typeBody} style={{ minWidth: "8.5rem" }} />
                           {!isOwnCompany && (
                             <Column header="Credits" body={creditsBody} style={{ width: "6.5rem" }} />
                           )}
                           {!isOwnCompany && (
                             <Column header="Quick Access" body={quickAccessBody} style={{ minWidth: "10rem" }} />
                           )}
                           {!isOwnCompany && (
                             <Column header="License History" body={licenceHistoryButtonBody} style={{ width: "5.5rem" }} />
                           )}
                           <Column
                              header="Default User"
                              body={defaultUserBody}
                              headerClassName="company-list-default-user-header"
                              bodyClassName="company-list-default-user-body"
                              style={{ minWidth: "6.5rem", textAlign: "center" }}
                           />
                           <Column header={isOwnCompany ? "Current Licence" : "Actions"} style={{ minWidth: "9rem" }} body={(rowData) => {
                            if (isOwnCompany) {
                              const lic = rowData.available_licence;
                              if (!lic) return "-";
                              return (
                                <div style={{ lineHeight: "1.6" }}>
                                  <span><b>Channels:</b> <span style={{ fontStyle: "italic" }}>{lic.channel}</span>, </span>
                                  <span><b>Live Agents:</b> <span style={{ fontStyle: "italic" }}>{lic.live_agent}</span>, </span>
                                  <span><b>Call Centers:</b> <span style={{ fontStyle: "italic" }}>{lic.role_ccadmin}</span>, </span>
                                  <span><b>Total Agents:</b> <span style={{ fontStyle: "italic" }}>{lic.role_ccagent}</span></span>
                                </div>
                              );
                            }
                            return RenderActionComponent(rowData);
                           }} />
                        </DataTable>
                     </div>
                  </div>
                  </Card.Body>
               </Card>
            </Col>
         </Row>
      </div>
      <RenderAddCreditModal
              show={showAddCreditModel}
              setShow={setShowAddCreditModel}
              setConfirmUpdateCredit={setConfirmCredits}
              creditsValue={addCreditsValue}
              setCreditsValue={setAddCreditsValue}
              availableCredits={addCreditsId ? Number(companylist.find(c => c.id === addCreditsId)?.credits_available || 0) : 0}
            />
             <RenderRemoveCreditModal
              show={showRemoveCreditModel}
              setShow={setShowRemoveCreditModel}
              setConfirmReduceUpdateCredit={setConfirmReduceCredits}
              removeCreditsValue={removeCreditsValue}
              setRemoveCreditsValue={setRemoveCreditsValue}
              availableCredits={removeCreditsId ? Number(companylist.find(c => c.id === removeCreditsId)?.credits_available || 0) : 0}
            />

            <RenderAddCreditModal
                    show={showAddTtsCreditModel}
                    setShow={setShowAddTtsCreditModel}
                    setConfirmUpdateCredit={setConfirmTtsCredits}
                    creditsValue={addTtsCreditsValue}
                    setCreditsValue={setAddTtsCreditsValue}
                    title="Add TTS Credits"
                    availableCredits={addTtsCreditsId ? Number(companylist.find(c => c.id === addTtsCreditsId)?.tts_credits || 0) : 0}
                  />
                  <RenderRemoveCreditModal
                    show={showRemoveTtsCreditModel}
                    setShow={setShowRemoveTtsCreditModel}
                    setConfirmReduceUpdateCredit={setConfirmReduceTtsCredits}
                    removeCreditsValue={removeTtsCreditsValue}
                    setRemoveCreditsValue={setRemoveTtsCreditsValue}
                    title="Remove TTS Credits"
                    availableCredits={removeTtsCreditsId ? Number(companylist.find(c => c.id === removeTtsCreditsId)?.tts_credits || 0) : 0}
                  />
{/* 
            <ToastNotification
                    show_toast={showToast}
                    set_show_toast={setShowToast}
                    {...toastProps}
                  /> */}
                  <Modal
                    show={showCompanyDetailsModal}
                    onHide={() => {
                      setShowCompanyDetailsModal(false);
                      setSelectedCompanyDetails(null);
                    }}
                    size="lg"
                    centered
                    className="user-details-modal"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Company Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {selectedCompanyDetails && (
                        <div className="user-details-list">
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--phone" aria-hidden="true">
                                <Phone size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Phone Number</span>
                            </span>
                            <span className="user-details-value">{selectedCompanyDetails.phone || "-"}</span>
                          </div>
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--address" aria-hidden="true">
                                <MapPin size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Address</span>
                            </span>
                            <span className="user-details-value">{selectedCompanyDetails.address || "-"}</span>
                          </div>
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--pincode" aria-hidden="true">
                                <Hash size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Pincode</span>
                            </span>
                            <span className="user-details-value">{selectedCompanyDetails.pincode || "-"}</span>
                          </div>
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--username" aria-hidden="true">
                                <User size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Created By</span>
                            </span>
                            <span className="user-details-value">
                              {selectedCompanyDetails.company_creator?.username || "-"}
                            </span>
                          </div>
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--name" aria-hidden="true">
                                <UserRound size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Updated By</span>
                            </span>
                            <span className="user-details-value">{getUpdatedByLabel(selectedCompanyDetails)}</span>
                          </div>
                          {getUpdatedByLabel(selectedCompanyDetails) === "—" && selectedCompanyDetails.updated_at && (
                            <div className="user-details-row">
                              <span className="user-details-field">
                                <span className="user-details-icon user-details-icon--expiry" aria-hidden="true">
                                  <CalendarClock size={15} strokeWidth={2.25} />
                                </span>
                                <span className="user-details-label">Last Updated</span>
                              </span>
                              <span className="user-details-value">
                                {formatDetailDateTime(selectedCompanyDetails.updated_at)}
                              </span>
                            </div>
                          )}
                          <div className="user-details-row">
                            <span className="user-details-field">
                              <span className="user-details-icon user-details-icon--joining" aria-hidden="true">
                                <Calendar size={15} strokeWidth={2.25} />
                              </span>
                              <span className="user-details-label">Created On</span>
                            </span>
                            <span className="user-details-value">
                              {formatDetailDateTime(selectedCompanyDetails.created_at)}
                            </span>
                          </div>
                          {selectedCompanyDetails.defaultUser?.username && (
                            <div className="user-details-row">
                              <span className="user-details-field">
                                <span className="user-details-icon user-details-icon--acl" aria-hidden="true">
                                  <UserRound size={15} strokeWidth={2.25} />
                                </span>
                                <span className="user-details-label">Default User</span>
                              </span>
                              <span className="user-details-value">
                                {selectedCompanyDetails.defaultUser.username}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </Modal.Body>
                  </Modal>

                  <Modal 
                    show={showStrategiesModal} 
                    onHide={() => {
                      setShowStrategiesModal(false)
                      setUserCallStrategies(null);
                      setUserCallStrategiesUserName(null);
                    }} 
                    centered
                    dialogClassName="company-strategies-modal"
                  >
                    <style>
                      {`
                        .company-strategies-modal .modal-dialog {
                          max-width: 420px !important;
                        }
                        .company-strategies-modal .modal-content {
                          border-radius: 14px !important;
                          overflow: hidden;
                          box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
                        }
                        .company-strategies-modal .modal-header {
                          background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
                          color: white !important;
                          border-bottom: none !important;
                          border-radius: 14px 14px 0 0 !important;
                          padding: 18px 24px !important;
                        }
                        .company-strategies-modal .modal-title {
                          color: white !important;
                          font-size: 20px !important;
                          font-weight: 600 !important;
                          letter-spacing: 0.3px !important;
                          margin: 0 !important;
                        }
                        .company-strategies-modal .btn-close {
                          filter: brightness(0) invert(1) !important;
                          opacity: 0.8 !important;
                          font-size: 20px !important;
                          transition: opacity 0.2s !important;
                        }
                        .company-strategies-modal .btn-close:hover {
                          opacity: 1 !important;
                        }
                        .company-strategies-modal .modal-body {
                          padding: 24px !important;
                        }
                      `}
                    </style>
                    <Modal.Header>
                      <Modal.Title>Company Call Strategies</Modal.Title>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={() => {
                          setShowStrategiesModal(false)
                          setUserCallStrategies(null);
                          setUserCallStrategiesUserName(null);
                        }}
                        aria-label="Close"
                      />
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ 
                        fontSize: "16px", 
                        fontWeight: "500", 
                        // color: "#1f2937", 
                        marginBottom: "16px" 
                      }}>
                        Company Name: <span style={{ fontWeight: "400" }}>{userCallStrategiesUserName}</span>
                      </div>
                      <div style={{ 
                        fontSize: "15px", 
                        fontWeight: "600", 
                        marginBottom: "12px", 
                        // color: "#1f2937" 
                      }}>
                        Call Strategies
                      </div>
                      <div>
                        {userCallStratgies ? (
                          userCallStratgies.split(", ").map((strategy, index) => (
                            <div key={index} style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              marginBottom: "12px",
                              fontSize: "14px",
                              // color: "#374151"
                            }}>
                              <div style={{
                                width: "20px",
                                height: "20px",
                                background: "#22c55e",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "12px",
                                marginRight: "10px",
                                flexShrink: 0
                              }}>
                                ✓
                              </div>
                              <span>{strategy.trim()}</span>
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: "14px" }}>No strategies assigned</div>
                        )}
                      </div>
                    </Modal.Body>
                    <div style={{
                      backgroundColor: "white",
                      borderTop: "1px solid #e5e7eb",
                      padding: "16px 24px",
                      marginTop: "0",
                      borderRadius: "0 0 14px 14px",
                      display: "flex",
                      justifyContent: "flex-end"
                    }}>
                      <BootstrapButton
                        onClick={() => {
                          setShowStrategiesModal(false)
                          setUserCallStrategiesUserName(null);
                          setUserCallStrategies(null);
                        }}
                        style={{
                          padding: "8px 22px",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "white",
                          background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
                          boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
                          transition: "all 0.2s",
                          cursor: "pointer"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
                        }}
                      >
                        Close
                      </BootstrapButton>
                    </div>
                  </Modal>
<Modal
  show={showGroupsModal}
  onHide={() => {
    setShowGroupsModal(false);
    setSelectedGroups([]);
    setSelectedCompanyName(null);
  }}
  centered
  dialogClassName="company-groups-modal"
>
  <style>
    {`
      .company-groups-modal .modal-header {
        background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
        color: white !important;
        border-bottom: none !important;
        border-radius: 14px 14px 0 0 !important;
        padding: 18px 24px !important;
      }
      .company-groups-modal .modal-title {
        color: white !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px !important;
        margin: 0 !important;
      }
      .company-groups-modal .btn-close {
        filter: brightness(0) invert(1) !important;
        opacity: 0.8 !important;
        font-size: 20px !important;
        transition: opacity 0.2s !important;
      }
      .company-groups-modal .btn-close:hover {
        opacity: 1 !important;
      }
      .company-groups-modal .modal-content {
        border-radius: 14px !important;
        overflow: hidden;
        box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
      }
      .company-groups-modal .modal-body {
        padding: 24px !important;
      }
      .company-groups-modal .modal-footer {
        border-top: 1px solid #e5e7eb;
        padding: 16px 24px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `}
  </style>
  <Modal.Header>
    <Modal.Title>Company Dialer Groups</Modal.Title>
    
    <button
      type="button"
      className="btn-close btn-close-white"
      onClick={() => {
        setShowGroupsModal(false);
        setSelectedGroups([]);
        setSelectedCompanyName(null);
      }}
      aria-label="Close"
    />
  </Modal.Header>
  <Modal.Body>
    <h6 className="mb-3">Company Name: {selectedCompanyName}</h6>
    {selectedGroups.length > 0
      ? selectedGroups.join(", ")
      : "No Dialer Groups Assigned"}
  </Modal.Body>
  <Modal.Footer>
    <Button
      onClick={() => {
        setShowGroupsModal(false);
        setSelectedGroups([]);
        setSelectedCompanyName(null);
      }}
      style={{
        padding: "8px 22px",
        border: "none",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: "500",
        color: "white",
        background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
        boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
        transition: "all 0.2s",
        cursor: "pointer"
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-2px)";
        e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(0)";
        e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
<Modal
  show={showLocationsModal}
  onHide={() => {
    setShowLocationsModal(false);
    setSelectedLocations([]);
    setSelectedCompanyName(null);
  }}
  centered
  dialogClassName="company-locations-modal"
>
  <style>
    {`
      .company-locations-modal .modal-header {
        background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
        color: white !important;
        border-bottom: none !important;
        border-radius: 14px 14px 0 0 !important;
        padding: 18px 24px !important;
      }
      .company-locations-modal .modal-title {
        color: white !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px !important;
        margin: 0 !important;
      }
      .company-locations-modal .btn-close {
        filter: brightness(0) invert(1) !important;
        opacity: 0.8 !important;
        font-size: 20px !important;
        transition: opacity 0.2s !important;
      }
      .company-locations-modal .btn-close:hover {
        opacity: 1 !important;
      }
      .company-locations-modal .modal-content {
        border-radius: 14px !important;
        overflow: hidden;
        box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
      }
      .company-locations-modal .modal-body {
        padding: 24px !important;
      }
      .company-locations-modal .modal-footer {
        border-top: 1px solid #e5e7eb;
        padding: 16px 24px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `}
  </style>
  <Modal.Header>
    <Modal.Title>Company Locations</Modal.Title>
    <button
      type="button"
      className="btn-close btn-close-white"
      onClick={() => {
        setShowLocationsModal(false);
        setSelectedLocations([]);
        setSelectedCompanyName(null);
      }}
      aria-label="Close"
    />
  </Modal.Header>
  <Modal.Body>
    <h6 className="mb-3">Company Name: {selectedCompanyName}</h6>
    {selectedLocations.length > 0
      ? selectedLocations.join(", ")
      : "No Locations Assigned"}
  </Modal.Body>
  <Modal.Footer>
    <Button
      onClick={() => {
        setShowLocationsModal(false);
        setSelectedLocations([]);
        setSelectedCompanyName(null);
      }}
      style={{
        padding: "8px 22px",
        border: "none",
        borderRadius: "8px",
        fontSize: "14px",
        fontWeight: "500",
        color: "white",
        background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
        boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
        transition: "all 0.2s",
        cursor: "pointer"
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-2px)";
        e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(0)";
        e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
      }}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
   <Modal.Header closeButton>
      <Modal.Title>Delete Company</Modal.Title>
   </Modal.Header>

   <Modal.Body>
      Are you sure you want to delete this company? Licence Values cannot be returned.
   </Modal.Body>

   <Modal.Footer>
      <Button
         label="Cancel"
         className="p-button-text"
         onClick={closeDeleteModal}
      />

      <Button
         label="Delete"
         className="p-button-danger"
         onClick={confirmDelete}
         disabled={buttonDisable}
      />
   </Modal.Footer>
</Modal>

<Modal
    show={showLicenceHistoryModal}
    onHide={() => {
        setShowLicenceHistoryModal(false);
        setSelectedLicenceCompanyId(null);
        setSelectedLicenceCompanyName(null);
    }}
    centered
    size="xl"
    dialogClassName="company-licence-history-modal"
>
    <style>
        {`
        .company-licence-history-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
        }
        .company-licence-history-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            letter-spacing: 0.3px !important;
            margin: 0 !important;
        }
        .company-licence-history-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
        }
        .company-licence-history-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
        }
        .company-licence-history-modal .modal-body {
            padding: 16px !important;
            max-height: 75vh;
            overflow-y: auto;
        }
        `}
    </style>
    <Modal.Header>
        <Modal.Title>
            Licence History — {selectedLicenceCompanyName}
        </Modal.Title>
        <button
            type="button"
            className="btn-close btn-close-white"
            onClick={() => {
                setShowLicenceHistoryModal(false);
                setSelectedLicenceCompanyId(null);
                setSelectedLicenceCompanyName(null);
            }}
            aria-label="Close"
        />
    </Modal.Header>
    <Modal.Body>
        {selectedLicenceCompanyId && (
            <LicenceHistoryList companyId={selectedLicenceCompanyId}
            displayName={selectedLicenceCompanyName} />
        )}
    </Modal.Body>
</Modal>

<CountryCodeDirectionsModal
  show={showCcDirectionsModal}
  onHide={() => {
    setShowCcDirectionsModal(false);
    setCcDirectionsData([]);
    setCcDirectionsOwner("");
  }}
  title="Company Country Codes"
  ownerLabel="Company Name"
  ownerName={ccDirectionsOwner}
  directions={ccDirectionsData}
/>
     </>
  )

}

export default CompanyList;